export type AttachmentWarningCopy = {
  title: string;
  body: string;
  linkText: string;
  linkUrl: string;
};

const SHARED_COPY = {
  title: 'Before you open this attachment',
};

const RACHEL_LINK = {
  linkText: 'How to stay safe from scams',
  linkUrl: 'https://www.zillow.com/learn/how-to-spot-rental-scams/',
};

export const ATTACHMENT_WARNING_COPY = {
  irene: {
    ...SHARED_COPY,
    body: "Attachments are not sent by Zillow. Be cautious of requests for payment or personal financial information. If something looks suspicious, don't engage with it.",
    linkText: 'How to avoid common rental scams',
    linkUrl: 'https://www.zillow.com/rentals-network/how-landlords-can-avoid-5-common-rental-scams/',
  },
  rachel: {
    zillow: {
      ...SHARED_COPY,
      body: "Attachments are not sent by Zillow. Be cautious of requests for payment or personal financial information. If something looks suspicious, don't engage with it.",
      ...RACHEL_LINK,
    },
    hotpads: {
      ...SHARED_COPY,
      body: "Attachments are not sent by HotPads. Be cautious of requests for payment or personal financial information. If something looks suspicious, don't engage with it.",
      ...RACHEL_LINK,
    },
  },
} as const;
